import { createGlobalStyle } from 'styled-components';
import { pixelTheme } from './theme/pixelTheme';

const Styles = createGlobalStyle`

    ${pixelTheme.animations.blink}
    ${pixelTheme.animations.float}
    ${pixelTheme.animations.pulse}
    ${pixelTheme.animations.glitch}

    * {
        image-rendering: pixelated;
        image-rendering: -moz-crisp-edges;
        image-rendering: crisp-edges;
    }

    body,
    html,
    a {
        font-family: 'Pixelify Sans', monospace;
        font-weight: 400;
    }

    html, body {
        height: 100%;
    }

    body {
        margin:0;
        padding:0;
        border: 0;
        outline: 0;
        background: ${pixelTheme.colors.background};
        background-image: 
            repeating-linear-gradient(
                0deg,
                transparent,
                transparent 2px,
                rgba(99, 102, 241, 0.05) 2px,
                rgba(99, 102, 241, 0.05) 4px
            ),
            repeating-linear-gradient(
                90deg,
                transparent,
                transparent 2px,
                rgba(99, 102, 241, 0.05) 2px,
                rgba(99, 102, 241, 0.05) 4px
            );
        overflow-x: hidden;
        color: ${pixelTheme.colors.text};
    }

    #root {
        min-height: 100vh;
        display: flex;
        flex-direction: column;
    }

    a:hover {
        color: ${pixelTheme.colors.primary};
        transform: scale(1.05);
        transition: all 0.1s steps(3);
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
        font-family: 'Pixelify Sans', monospace;
        color: ${pixelTheme.colors.secondary};
        font-size: 22px;
        font-weight: 600;
        line-height: 2.5rem;
        margin: 0.5rem 0 1rem 0;
        text-shadow: 2px 2px 0 rgba(99, 102, 241, 0.1);
        letter-spacing: 1px;
        font-weight: 600;
      
        @media only screen and (max-width: 414px) {
          font-size: ${pixelTheme.pixelSizes.medium};
          line-height: 2rem;
        }
    }

    h1 {
        font-family: 'Pixelify Sans', monospace;
        font-size: 36px;
        font-weight: 700;
        animation: glitch 2s infinite;
        line-height: 3rem;
        
        @media only screen and (max-width: 414px) {
            font-size: 18px;
            line-height: 2rem;
        }
    }

    span,
    p {
        color: ${pixelTheme.colors.text};
        margin: 0.5rem 0;
        font-family: 'Pixelify Sans', monospace;
        font-size: 18px;
        font-weight: 600;
        letter-spacing: 0.5px;
        line-height: 1.8;
    }

    a {
        text-decoration: none;
        outline: none;
        color: ${pixelTheme.colors.primary};
        position: relative;
        transition: all 0.1s steps(3);

        :hover {
            color: ${pixelTheme.colors.accent};
        }
    }
    
    *:focus {
        outline: 2px solid ${pixelTheme.colors.primary};
        outline-offset: 2px;
    }

    button:active {
        transform: translateY(2px);
    }

    .about-block-image svg {
        text-align: center;
    }

    .ant-drawer {
        .ant-drawer-content {
            background: ${pixelTheme.colors.dark};
            border-left: 4px solid ${pixelTheme.colors.primary};
        }
    }

    .ant-drawer-body {
        display: flex;
        flex-direction: column;
        padding: 1.25rem;
        text-align: left;
        padding-top: 2.5rem;
        padding-right: 2rem;
        background: ${pixelTheme.colors.dark};
    }

    .anticon,
    .ant-notification-notice-icon-success {
        color: ${pixelTheme.colors.accent};
    }

    ::selection {
        background: ${pixelTheme.colors.primary};
        color: ${pixelTheme.colors.background};
    }

    ::-webkit-scrollbar {
        width: 12px;
    }

    ::-webkit-scrollbar-track {
        background: ${pixelTheme.colors.backgroundLight};
        border: 2px solid ${pixelTheme.colors.border};
    }

    ::-webkit-scrollbar-thumb {
        background: ${pixelTheme.colors.primary};
        border: 2px solid ${pixelTheme.colors.border};
    }

    ::-webkit-scrollbar-thumb:hover {
        background: ${pixelTheme.colors.secondary};
    }
`;

export default Styles;
